import remote from './remote';

export function getSlates(query = {}) {
  return remote.get('slates/upcoming', query);
}

export function getSlate(id) {
  return remote.get(`slates/${id}?embed=games.teams,games.players`);
}

export function createChallenge(data) {
  return remote.post('custom_challenges', data);
}

export function getPrizes(data) {
  return remote.get('custom_challenges/prizes', data);
}
